import React from "react";
import "../styles/ImportantDates.css";

const ImportantDates = () => {
  const dates = [
    { label: "Call for Papers", date: "15th January, 2026" },
    {
      label: "Submission Closing Date",
      date: (
        <>
          <s>25th May, 2026</s>
          {" "}31st May, 2026
          <br />
          <b>(Hard Deadline)</b>
        </>
      ),
    },
    { label: "Paper Acceptance Notification", date: "15th June, 2026" },
    { label: "Camera Ready Paper Submission", date: "21th June, 2026" },
    { label: "Registration Date", date: "19th June, 2026" },
    { label: "Conference Dates", date: "9th - 10th July 2026" },
  ];

  return (
    <section id="important-dates" className="important-dates">
      <div className="container">
        <h2 className="section-title">Important Dates</h2>
        <p className="section-subtitle">
          International Conference on Emerging Trends and Technologies in
          Applications of Computer Science (ICETTACS 2026)
        </p>

        <div className="dates-grid">
          {dates.map((item, index) => (
            <div key={index} className="date-card">
              <div className="date-icon">
                <i className="far fa-calendar"></i>
              </div>
              <h3>{item.label}</h3>
              <p>{item.date}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImportantDates;
